import React from 'react';
import RenderItem from './RenderItem'
import OrderPage from './OrderPage';
import { connect } from 'react-redux';
import { MDBInput, MDBBtn } from 'mdb-react-ui-kit';
import axios from 'axios';
import { baseURL } from '../../api/baseURL';
import Pagination from '../Pagination';
import debounce from 'debounce';
import Loader from '../../Loader';
import Modal from '../../Modal';
import ExportButton from '../ExportButton';
import { isMainAdmin } from '../../utils/isMainAdmin';
import AdminShell from '../layout/AdminShell';
import { countPillStyle, chipBarStyle, chipStyle, toolbarRowStyle, searchBoxWrapperStyle, thStyle } from '../layout/listUi';

const ORDER_STATUS_CHIPS = [
    { key: '', label: 'All' },
    { key: 'assigned_orders', label: 'Assigned' },
    { key: 'pending', label: 'Pending / Failed' },
    { key: 'paid', label: 'Paid' },
    { key: 'ongoing', label: 'Ongoing' },
    { key: 'processing', label: 'Processing' },
    { key: 'completed', label: 'Completed' },
    { key: 'refund_processing', label: 'Refund Initiated' },
    { key: 'refunded', label: 'Refunded' },
];

type State = {
    requested: boolean,
    err: any,
    ordersList: any,
    photoOpen: boolean,
    modalOpen: boolean,
    currentPage: number,
    searchedList: any,
    sortBy: string,
    requestedPhotographer: any,
    completedOrder: boolean
};

class OrderList extends React.Component<{ history: any, token?: string, role?: string }> {
    state: State = {
        requested: false,
        err: false,
        ordersList: null,
        photoOpen: false,
        modalOpen: false,
        searchedList: null,
        currentPage: 1,
        sortBy: window.location.search.split("sortBy=")?.[1] || "",
        requestedPhotographer: false,
        completedOrder: false
    }

    componentDidMount(): void {
        if (!this.props.token) {
            window.location.pathname = "/";
        }
        else {
            this.getOrdersList(parseInt(window.location.search.split("?page=")[1]) ? parseInt(window.location.search.split("?page=")[1]) : 1);
        }
    }

    getOrdersList = (pageNumber: number) => {
      //console.log(this.state.sortBy)
        if (!this.state.requested) {
            this.setState({ err: false, requested: true });
            axios.get(`${baseURL}/orders?page=${pageNumber}&limit=10&sortBy=${this.state.sortBy}`,
                {
                    headers: { Authorization: `Bearer ${this.props.token}` }
                })
                .then((response: any) => {
                  //console.log(response);
                    if (response?.data?.message === "success") {
                        this.setState({ ordersList: response?.data, requested: false, err: false, currentPage: pageNumber });
                    }
                    else {
                        this.setState({ err: true, requested: false });
                    }
                })
                .catch((error: any) => {
                  //console.log(error);
                    this.setState({ err: true, requested: false });
                })
        }
    }

    completeOrder = (storage_link: string, receiptId: string) => {
        if (!this.state.requested) {
            this.setState({ err: false, requested: true });
            return axios.post(`${baseURL}/complete-order`,
                {
                    storage_link,
                    receipt_id: receiptId
                },
                {
                    headers: { Authorization: `Bearer ${this.props.token}` }
                })
                .then((response: any) => {
                  //console.log(response);
                    if (response?.data?.message === "success") {
                        for (let i = 0; i < this.state.ordersList.orders.length; i++) {
                            if (this.state.ordersList.orders[i]?.receipt_id === receiptId) {
                                let temp = this.state.ordersList;
                                temp.orders[i].status = "completed";
                                break;
                            }
                        }
                        this.setState({ requested: false, err: false, completedOrder: true });
                    }
                    else {
                        this.setState({ err: true, requested: false });
                    }
                })
                .catch((error: any) => {
                  //console.log(error);
                    this.setState({ err: true, requested: false });
                })
        }
        return Promise.resolve();
    }

    cancelOrder = (receiptId: string) => {
        if (!this.state.requested) {
            this.setState({ err: false, requested: true });
            return axios.post(`${baseURL}/cancel-order`,
                {
                    receipt_id: receiptId
                },
                {
                    headers: { Authorization: `Bearer ${this.props.token}` }
                })
                .then((response: any) => {
                  //console.log(response);
                    if (response?.data?.message === "success") {
                        if (this.state.ordersList?.orders?.length) {
                            for (let i = 0; i < this.state.ordersList.orders.length; i++) {
                                if (this.state.ordersList.orders[i]?.receipt_id === receiptId) {
                                    const temp = this.state.ordersList;
                                    temp.orders[i].status = "refund_processing";
                                    this.setState({ requested: false, err: false, ordersList: temp });
                                    return;
                                }
                            }
                        }
                        this.setState({ requested: false, err: false });
                    }
                    else {
                        this.setState({
                            err: response?.data?.message || "cancel_failed",
                            requested: false
                        });
                    }
                })
                .catch((error: any) => {
                    const backendMsg = error?.response?.data?.message;
                  //console.log(error);
                    this.setState({ err: backendMsg || "cancel_failed", requested: false });
                })
        }
        return Promise.resolve();
    }

    // Client-reported: Request Photographer / Reassign no longer open an
    // email-entry modal — they redirect to the Availability tab, which
    // auto-selects this order and shows real photographers
    // (filtered by the order's required services) with a Request button.
    redirectToAvailability = (receiptId: string) => {
        window.location.href = `/availability?receipt_id=${receiptId}`;
    }

    // Reassign needs the currently-accepted photographer unassigned first so
    // the slot becomes "open" again — only then does it show up as a normal
    // candidate-matching order on the Availability tab.
    // `serviceType`: on a multi-service order, the admin picks which single
    // service's slot to reassign — only that slot is touched, the other
    // service(s) on the order stay assigned. Omitted entirely on single-service
    // orders, where the whole-order unassign behavior is unchanged.
    unassignAndRedirectToAvailability = (receiptId: string, serviceType?: string) => {
        if (this.state.requested) return;
        this.setState({ err: false, requested: true });
        axios.post(`${baseURL}/unassign-order`,
            { receipt_id: receiptId, ...(serviceType ? { service_type: serviceType } : {}) },
            { headers: { Authorization: `Bearer ${this.props.token}` } })
            .then(() => {
                this.redirectToAvailability(receiptId);
            })
            .catch((error: any) => {
                const backendMsg = error?.response?.data?.message;
                this.setState({ err: backendMsg === "not_assigned" ? "not_assigned" : backendMsg === "order_not_reassignable" ? "order_not_reassignable" : (backendMsg || "reassign_failed"), requested: false });
            })
    }

    getSearchList = (searchText: string) => {
      //console.log(this.state.sortBy)
        if (!this.state.requested) {
            this.setState({ err: false, requested: true });
            axios.get(`${baseURL}/orders?search=${searchText}&limit=10&sortBy=${this.state.sortBy}`,
                {
                    headers: { Authorization: `Bearer ${this.props.token}` }
                })
                .then((response: any) => {
                  //console.log(response);
                    if (response?.data?.message === "success") {
                        this.setState({ searchedList: response?.data, requested: false, err: false });
                    }
                    else {
                        this.setState({ err: true, requested: false });
                    }
                })
                .catch((error: any) => {
                  //console.log(error);
                    this.setState({ err: true, requested: false });
                })
        }
    }

    onPageChange = (pageNumber: number) => {
        this.getOrdersList(pageNumber);
    }

    // Change 91: resolve a single per-order admin alert without a full page reload.
    // Optimistically removes the alert from the matching order in both ordersList
    // and searchedList. On failure, refetches so state stays consistent.
    resolveAlert = (alertId: string, receiptId: string) => {
        if (!alertId) return;
        const stripAlert = (list: any) => {
            if (!list?.orders?.length) return list;
            const next = { ...list, orders: list.orders.map((o: any) => {
                if (o?.receipt_id !== receiptId) return o;
                return { ...o, alerts: (o?.alerts || []).filter((a: any) => String(a?._id) !== String(alertId)) };
            })};
            return next;
        };
        this.setState({
            ordersList: stripAlert(this.state.ordersList),
            searchedList: stripAlert(this.state.searchedList),
        });
        axios.post(`${baseURL}/resolve-alert`, { alertId }, {
            headers: { Authorization: `Bearer ${this.props.token}` }
        }).catch(() => {
            // Rollback by refetching the current page on failure.
            this.getOrdersList(this.state.currentPage);
        });
    }

    toggleOpen = (orderData: any) => {
        if (this.state.modalOpen) {
            this.setState({ modalOpen: false });
        }
        else if (!this.state.modalOpen) {
            this.setState({ modalOpen: orderData });
        }
    }

    onSearch = debounce((searchText: string) => {
        if (searchText.length > 2) {
            this.getSearchList(searchText);
        }
    }, 100);

    onClickClear = () => {
        let searchInputEl: any = document.getElementById("search_input");
        if (searchInputEl?.value) {
            searchInputEl.value = "";
        }

        if (this.state.sortBy) {
            window.location.href = "/orders";
        }

        if (this.state.searchedList) {
            this.setState({ searchedList: null });
        }
    }

    toggleModal = () => {
        if (this.state.err || this.state.requestedPhotographer || this.state.completedOrder) {
            this.setState({ err: false, requestedPhotographer: false, completedOrder: false });
        }
    }

    render() {
        return (
            <AdminShell activePage="orders" title="Orders" subtitle="All customer bookings, status, and assignment" topbarActions={<ExportButton endpoint="/export/orders" />}>
                <Modal open={this.state.err || this.state.requestedPhotographer || this.state.completedOrder} hideSec primaryText="Okay" title='Update' onConfirm={this.toggleModal} toggleOpen={this.toggleModal} content={<h6>{this.state.completedOrder ? "Storage link is sent and order is marked as complete" : this.state.requestedPhotographer === "request_already_sent" ? "Request is already sent to some photographer" : this.state.requestedPhotographer ? "Request is sent to the photographer" : this.state.err === "4_hours_restriction" ? "Cannot assign photographer: the shoot has already started or passed. (Test / Quick Test orders are exempt on the server.)" : this.state.err === "already_assigned" ? "Photographer is already assigned to an order" : this.state.err === "not_verified" ? "Photographer is not verified" : this.state.err === "photographer_not_found" ? "Photographer doesn't exist with that email" : this.state.err === "order_not_found" ? "Order not found for this receipt id" : this.state.err === "email_failed" ? "Photographer was assigned but the notification email failed to send. Please retry or contact the photographer directly." : this.state.err === "failed_to_assign" ? "Failed to assign the photographer. Please try again." : this.state.err === "unauthorized" ? "You are not authorized to perform this action. Please log in again." : this.state.err === "backend_unreachable" ? "Admin Server could not reach the main Backend. Set BACKEND_API_URL on the Admin Server process and ensure the Backend is running. Check Admin Server terminal logs." : this.state.err === "server_error" ? "Server error while processing the request. Please try again in a moment." : this.state.err === "order_not_cancellable" ? "This order cannot be cancelled (already completed, refunded, or refund already in progress)." : this.state.err === "missing_payment_reference" ? "Cannot refund: payment record is missing a Razorpay payment id. Check the transaction in the database or process the refund manually in Razorpay." : this.state.err === "refund_failed" ? "Razorpay refund failed. Check Admin Server logs and Razorpay dashboard; you may need to refund manually." : this.state.err === "cancel_failed" ? "Cancel request failed. Please try again or check server logs." : this.state.err === "not_assigned" ? "This order doesn't currently have a photographer assigned, so there's nothing to reassign." : this.state.err === "slot_not_found" ? "That service slot could not be found on this order. Please refresh and try again." : this.state.err === "order_not_reassignable" ? "This order cannot be reassigned (already completed, refunded, or refund already in progress)." : this.state.err === "reassign_failed" ? "Reassign failed. Please try again." : (typeof this.state.err === "string" && this.state.err) ? this.state.err : "Something went wrong, please try again later"}</h6>} />
                {this.state.requested ? <Loader /> : null}
                            <div className="row ">
                                <div className="col-12 grid-margin">
                                    <div className="card">
                                        <div className="card-body">
                                            <h4 className="card-title">
                                                Orders
                                                {this.state.ordersList?.total ? <span style={countPillStyle}>{this.state.ordersList.total}</span> : null}
                                            </h4>
                                            <div style={chipBarStyle}>
                                                {ORDER_STATUS_CHIPS.map((chip) => (
                                                    <span
                                                        key={chip.key || 'all'}
                                                        style={chipStyle(this.state.sortBy === chip.key)}
                                                        onClick={() => { window.location.href = chip.key ? `?sortBy=${chip.key}` : '/orders'; }}
                                                    >
                                                        {chip.label}
                                                    </span>
                                                ))}
                                            </div>
                                            <div style={toolbarRowStyle}>
                                                <div style={searchBoxWrapperStyle}>
                                                    <MDBInput
                                                        onChange={(e) => {
                                                            this.onSearch(e.target.value)
                                                        }}
                                                        contrast label="Search by Name / Category" id="search_input" type="text" style={{ border: 'none' }} />
                                                </div>
                                                <MDBBtn onClick={() => { this.onClickClear() }} style={{ width: '100px' }} color='secondary' rippleColor='light'>Clear</MDBBtn>
                                            </div>
                                            <div className="table-responsive">
                                                {(this.state.searchedList?.orders?.length || this.state.ordersList?.orders?.length) ? <table className="table">
                                                    <thead>
                                                        <tr>
                                                            {/* Change 91: chevron column to expand per-order alerts */}
                                                            <th style={{ ...thStyle, width: 36 }}> </th>
                                                            <th style={thStyle}> Client Name </th>
                                                            <th style={thStyle}> Services </th>
                                                            <th style={thStyle}> Date &amp; Time </th>
                                                            <th style={thStyle}> Order Status </th>
                                                            <th style={thStyle}> Assigned To </th>
                                                            <th style={thStyle}> Action </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.state.searchedList?.orders?.length ?
                                                            this.state.searchedList?.orders.map((item: any) => {
                                                                return <RenderItem key={item?.receipt_id || item?._id} requested={this.state.requested} err={this.state.err} toggleOpen={this.toggleOpen} item={item} servicePricing={this.state.ordersList?.miscData?.service_pricing} redirectToAvailability={this.redirectToAvailability} completeOrder={this.completeOrder} cancelOrder={this.cancelOrder} resolveAlert={this.resolveAlert} isMainAdmin={isMainAdmin(this.props.role)} />
                                                            }) : this.state.ordersList?.orders?.length ?
                                                                /*
                                                                 * Always render every order returned by the backend.
                                                                 * Previously hid orders with order_action === "accepted" when sortBy was empty,
                                                                 * which combined with status/payment-status quirks caused freshly created
                                                                 * pending orders to be invisible until their state changed (accept/cancel).
                                                                 */
                                                                this.state.ordersList?.orders.map((item: any) => (
                                                                    <RenderItem key={item?.receipt_id || item?._id} requested={this.state.requested} err={this.state.err} toggleOpen={this.toggleOpen} item={item} servicePricing={this.state.ordersList?.miscData?.service_pricing} redirectToAvailability={this.redirectToAvailability} unassignAndRedirectToAvailability={this.unassignAndRedirectToAvailability} completeOrder={this.completeOrder} cancelOrder={this.cancelOrder} resolveAlert={this.resolveAlert} isMainAdmin={isMainAdmin(this.props.role)} />
                                                                ))
                                                                : null}
                                                    </tbody>
                                                </table> : <div style={{ display: 'flex', justifyContent: 'center', padding: 15, paddingTop: 30 }}>
                                                    <div className="badge badge-outline-secondary" style={{ fontSize: 16 }}>No Data</div>
                                                </div>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {(this.state.ordersList?.total / 10) > 1 ? <Pagination onPageChange={this.onPageChange} currentPage={this.state.currentPage} totalPages={(this.state.ordersList?.total / 10) < 1 ? (this.state.ordersList?.total / 10) : Math.ceil(this.state.ordersList?.total / 10)} maxVisible={5} /> : null}
                <OrderPage open={this.state.modalOpen} toggleOpen={this.toggleOpen} />
            </AdminShell>
        );
    }
}

const mapDispatchToProps = (dispatch: Function) => {
    return {
        dispatch
    }
}

const mapStateToProps = (state: any, ownProps: any) => {
    return {
        token: state.auth.token,
        role: state.auth.role,
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderList);
